import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';

import { fetchData } from '../../../../helpers/methods';

import SpinnerContainer from '../../../../component-library/spinner-container';
import Pagination from '../../../../component-library/pagination';
import SearchList from '../../../../component-library/search-list';

import Sort from './sort';

const TaxonomyResults = ({
	id = null,
	classificationName = '',
}) => {
	const navigate = useNavigate();
	const [loading, setLoading] = useState(true);
	const [data, setData] = useState([]);
	const [query, setQuery] = useState({
		pageSize: 12,
		pageOffset: 0,
		sortField: 'sortName',
		sortOrder: 'asc',
		searchString: '',
	});
	const [pagination, setPagination] = useState({
		totalPages: 1,
		currentPage: 1,
	});

	const getData = () => {
		if (id !== null) {
			setLoading(true);
			const filterString = `&classificationIds=${id}`;

			fetchData({
				uri: `/api/web/catalog/search?text=${query.searchString}&sortField=${query.sortField}:${query.sortOrder}&pageSize=${query.pageSize}&offset=${query.pageOffset}${filterString}`,
				method: 'GET',
			})
				.then(res => {
					const metaData = res.body.metadata;
					const listData = res.body.results;
					setPagination({
						...pagination,
						totalPages: Math.ceil(metaData.totalSize / query.pageSize),
					});
					setData(listData);
					setLoading(false);
				})
				.catch(() => {
					setLoading(false);
				});
		}
	};

	const handlePagination = currentPage => {
		const newOffset = (currentPage * query.pageSize) - query.pageSize;
		setPagination({
			...pagination,
			currentPage,
		});
		setQuery({
			...query,
			pageOffset: newOffset,
		});
	};

	const handleCardClick = newId => {
		navigate(`../details/${newId}`, { state: { from: 'taxonomy' } });
	};

	useEffect(() => {
		getData();
	}, [query]);

	useEffect(() => {
		setPagination({
			...pagination,
			currentPage: 1,
		});
		setQuery({
			...query,
			pageOffset: 0,
		});
	}, [id]);

	return (
		<div>
			{id === null ? (
				<p className="grey-text text-center margin-top-16">Select a classification to view results</p>
			) : (
				<>
					{classificationName?.length > 0 ? (
						<h3>{classificationName}</h3>
					) : null}
					{!loading && (
						data?.length > 0 ? (
							<div>
								<Sort
									query={query}
									setQuery={newQuery => setQuery(newQuery)}
									pagination={pagination}
									setPagination={newPagination => setPagination(newPagination)}
									topMargin={classificationName?.length > 0}
								/>
								<div>
									{data.map(item => (
										<SearchList
											key={item.id}
											id={item.id}
											title={item.name}
											interfaceType={item.interfaceType?.name}
											version={item.version}
											description={item.description}
											storefront={item.storefront}
											state={item.state}
											objectType={item.objectType}
											handleCardClick={newId => handleCardClick(newId)}
										/>
									))}
								</div>
								<Pagination
									totalPages={pagination.totalPages}
									currentPage={pagination.currentPage}
									action={currentPage => handlePagination(currentPage)}
								/>
							</div>
						) : (
							<div>
								<p className="grey-text text-center margin-top-24">No results found</p>
							</div>
						)
					)}
					{loading && (
						<SpinnerContainer />
					)}
				</>
			)}
		</div>
	);
};

export default TaxonomyResults;

TaxonomyResults.propTypes = {
	id: PropTypes.number,
	classificationName: PropTypes.string,
};
